import axios from '@/libs/http'

/**
 * 获取管理员店员信息申请列表
 * */
export const getClerkCheckListForAdmin = (status, type, sex, pageNo, pageSize) => {
    return axios.request({
        url: '/s/a/clerkInfoCheck/list',
        params: {
            status,
            type,
            sex,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取组长店员信息申请列表
 * */
export const getClerkCheckListForLeader = (status, type, sex, pageNo, pageSize) => {
    return axios.request({
        url: '/s/l/leader/list',
        params: {
            status,
            type,
            sex,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取会长店员信息申请列表
 * */
export const getClerkCheckListForGuilder = (status, type, sex, pageNo, pageSize) => {
    return axios.request({
        url: '/s/g/guilder/list',
        params: {
            status,
            type,
            sex,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取店员信息申请详情
 * */
export const getClerkCheckDetail = (clerkId, clerkCheckId,status) => {
    let data = new URLSearchParams()
    data.append("clerkId", clerkId)
    data.append("clerkCheckId",clerkCheckId)
    data.append("status",status)
    return axios.request({
        url: '/s/clerkInfoCheck/detail',
        data,
        method: 'post'
    })
}

//店员信息的审核状态
export const getAuditStatus = (clerkCheckIds,clerkId,status,remark) => {
    let data = new URLSearchParams()
    data.append("clerkCheckIds", clerkCheckIds)
    data.append("clerkId",clerkId)
    data.append("status",status)
    if(remark){
        data.append("remark",remark)
    }
    return axios.request({
        url: '/s/clerkInfoCheck/check',
        data,
        method: 'post'
    })
}
